import { AxiosPromise } from 'axios';
import { IntroduceApi } from '@/utils/http';

// 获取海报上传参数
export const fetchPosterUploadToken = ():AxiosPromise<MarketingAPI.Response.IPosterUploadToken> =>
  IntroduceApi.get('/poster/qiniu/token/generate');

// 上传海报文件
export const fetchUploadPoster = (
  data:FormData,
):AxiosPromise<MarketingAPI.Response.IUploadPoster> =>
  IntroduceApi.post('https://up-z0.qiniup.com', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
    },
    withCredentials: false,
  });

// 获取海报复制文案
export const fetchGetPosterCopywriting = (
  params:PosterAPI.Request.IGetPoster,
) => ():AxiosPromise<PosterAPI.Response.PosterCopywritingListType> =>
  IntroduceApi.get('/poster/copywriting/list', { params });

// 获取海报分享地址
export const fetchGetPosterUrl = (
  body:PosterAPI.Request.IGetPosterUrl,
) => ():AxiosPromise<PosterAPI.Response.PosterUrlType> =>
  IntroduceApi.post('/invitation/qrcode/url', body);

// 获取海报分享模板
export const fetchGetPosterTemplate = (
  params:PosterAPI.Request.IGetPoster,
) => ():AxiosPromise<PosterAPI.Response.IPosterTemplate[]> =>
  IntroduceApi.get('/poster/template/list/v2', { params });

// 获取海报个性化ID
export const generatePosterId = () => ():AxiosPromise<PosterAPI.Response.IPosterId> =>
  IntroduceApi.get('/poster/users/generate/id');

// 保存海报埋点
export const savePoster = (
  body:PosterAPI.Request.ISavePoster,
) => ():AxiosPromise => IntroduceApi.post('/poster/users/save', body);
